<template>
  <modal
    :title="editing ? 'Edit saved search' : 'Save search'"
    :open="open"
    @close="closeModal"
  >
    <p>Review and give your custom search a name.</p>

    <form @submit.stop.prevent="save">
      <text-input
        ref="nameInput"
        v-model.trim="name"
        label="Name"
        required
        maxlength="80"
      />

      <div v-if="query" class="grid">
        <div>Search term:</div>
        <strong>{{ editing ? editing.query : query }}</strong>
      </div>

      <div v-if="filterDescription" class="grid">
        <div>Filters:</div>
        <strong>{{ filterDescription }}</strong>
      </div>

      <btn
        type="submit"
        :loading="saving"
        :disabled="!name.trim()"
      >
        Save
      </btn>
    </form>
  </modal>
</template>

<script>
import { mapState } from 'vuex';

import { getFilterDescription } from '@cardladder/shared/utils/ladder.util';

import { authService } from '@/services';

export default {
  props: {
    open: Boolean,
    query: String,
    filters: Object,
    type: String,
    editing: Object,
  },

  data() {
    return {
      name: '',
      saving: false,
    };
  },

  watch: {
    open: {
      async handler(value) {
        if (value) {
          if (this.editing) {
            this.name = this.editing.name;
          } else if (this.query) {
            this.name = this.query;
          }

          await this.$nextTick();
          this.$refs.nameInput.focus();
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    filterDescription() {
      return getFilterDescription(this.editing ? this.editing.filters : this.filters);
    },
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },

    async save() {
      this.saving = true;

      if (this.editing) {
        await authService.updateSavedFilter(this.user.uid, {
          ...this.editing,
          name: this.name,
        });
      } else {
        await authService.addToSavedFilters(this.user.uid, {
          name: this.name,
          type: this.type,
          query: this.query,
          filters: this.filters,
        });
      }

      this.saving = false;
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-top: -$gp * .5;
}

.grid {
  display: grid;
  grid-gap: $gp;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: $gp * .5;

  &:last-of-type {
    margin-bottom: $gp;
  }
}
</style>
